<template>
	<md-card>
		<md-card-header md-alignment="space-between">
			<h4 class="title">
				<md-icon>assignment</md-icon>
				단체 회원 목록
			</h4>
		</md-card-header>
		<md-card-content>
			<div class="table-header-info">
				<div>총 {{ total }} 건의 검색결과가 있습니다.</div>
				<div style="display: flex;">
          <div >
            <label>납부여부</label>
            <input type="radio" value="" v-model="payYn" @change="onChangePayYn">전체
            <input type="radio" value="Y" v-model="payYn" @change="onChangePayYn">Y
            <input type="radio" value="N" v-model="payYn" @change="onChangePayYn">N
          </div>
          <div style="padding-left: 15px;">
					  <select v-model="pagination.perPage" name="pages" @change="perPageChange">
						  <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
							  {{ item }}
						  </option>
					  </select>
          </div>
				</div>
			</div>

			<grid ref="GroupMemberListGrid"
						:data="gridProps.data"
						:columns="gridProps.columns"
						:options="gridProps.options"
						:theme="gridProps.theme"
						:rowHeaders="gridProps.rowHeaders"
						:columnOptions="gridProps.columnOptions"
						:language="gridProps.lang"
						@response="response"
			></grid>
		</md-card-content>
		<md-card-actions md-alignment="right">
			<md-button class="md-info md-sm" @click="onClickChangeFeeStatus(true)">
				<md-icon>check</md-icon>
				납부처리
			</md-button>
			<md-button class="md-warning md-sm" @click="onClickChangeFeeStatus(false)">
				<md-icon>clear</md-icon>
				미납처리
			</md-button>
		</md-card-actions>
	</md-card>
</template>
<script>

import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

import Swal from "sweetalert2";

export default {
  name: "GroupMemberListComp",
  props: {
  },
  components: {
    grid: Grid
  },

  created() {
      this.initGrid();
  },

  computed: {
      total: function() {
        return this.pagination.total
      }
  },
  data() {
    return {
      payYn: "",
      branchInfo : null,
      gridProps: {},
      pagination: {
        perPage: 15,
        page: 1,
        perPageOptions: [15, 20, 30, 40, 50, 1000],
        total: 0
      }
    };
  },
  methods: {
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_MEMBER_LIST2, false, this.pagination, ['rowNum', 'checkbox']);
      this.gridProps['el'] = this.$refs.GroupMemberListGrid;
      this.gridProps['columns']= [
          {header: '교우번호', name: 'memberNo', align : 'center', sortable: true},
          {header: '교우명', name: 'memberHnm', align : 'center', sortable: true},
          {header: '주민번호', name: 'registerNo', align : 'center', sortable: true},
          {header: '학과', name: 'classNm', align : 'center', sortable: true},
          {header: '학번', name: 'hakbun', align : 'center', sortable: true},
          {header: '평생회원여부', name: 'memberGb', align : 'center', sortable: true},
          {header: '납부여부', name: 'payYn', align : 'center' ,sortable:true},
          {header: '단체id', name: 'branchId', hidden:true}
        ];
      this.gridProps['options'].bodyHeight = 250;
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.GroupMemberListGrid, event, this.pagination);
    },
    sendQuery (branchInfo) {
      if(branchInfo){
        this.branchInfo = branchInfo;
			}
      this.$refs.GroupMemberListGrid.invoke("readData", this.$refs.GroupMemberListGrid.invoke("getPagination")._currentPage, {branchId : branchInfo.branchId, feeDate: branchInfo.feeDate, feeTime: branchInfo.feeTime, payYn:this.payYn});
    },
    onClickChangeFeeStatus(status) {
      let selectedRows = this.$refs.GroupMemberListGrid.invoke('getCheckedRows');
      let modalOptions = {
        type: "warning",
        showCancelButton: false,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "확인",
        buttonsStyling: false,
      };

      if(!selectedRows.length){
        modalOptions['html'] = '회원을 선택해 주세요';
        Swal.fire(modalOptions);
        return;
			}

      if(!this.branchInfo.feeTime || this.branchInfo.feeTime == ''){
        modalOptions['html'] = '납부내역을 선택해 주세요';
        Swal.fire(modalOptions);
        return;
      }

      let selecteMemberIds = [];
      let apiUrl = status ? URL_CONST.INSERT_BRANCH_MEMBER_FEE : URL_CONST.DELETE_BRANCH_MEMBER_FEE;
      let params = [];

      selectedRows.forEach((row)=>{        
        selecteMemberIds.push(row.memberNo);
        params.push({
          memberNo : row.memberNo,
          feeDate : this.branchInfo.feeDate,
          feeTime : this.branchInfo.feeTime,
          feeCd : row.feeCd,
          feeYear : row.feeYear,
          feeGb : row.branchGb == "J" ? "02" : row.branchGb == "B" ? "03" : "01",
          feeAmt : 0,
          feeCommission : 0,
          feeWay : row.feeWay, 
          branchId : row.branchId,
          bankCd : row.bankCd,
          feeEtc : row.feeEtc
        })
      });

      kuaaApi.sendServer(
        apiUrl,
        params,
        "post",
        response => {

          if (response.data.success){
            let errListOpts = '';
            if(typeof response.data.data !== 'string' && response.data.data.length > 0){
              let errList = [];
              response.data.data.forEach((d, idx) => {
                errList.push(d.memberNo);
              });
              errListOpts = `<br>미처리교우 - [` + errList + `]`;
            }
            modalOptions.html = status ? `납부처리 되었습니다.`+errListOpts : `미납처리 되었습니다.`+errListOpts;
            Swal.fire(modalOptions);
            this.sendQuery(this.branchInfo);
          } else {
            modalOptions.html = status ? `납부처리 실패 하였습니다.` : `미납처리 실패 하였습니다..`;
            Swal.fire(modalOptions);
          }
        }
      );

    },

    onChangePayYn:function(){
      if(this.branchInfo) this.sendQuery (this.branchInfo);
    }
  }
};
</script>

<style lang="css" scoped>

</style>